/**
 * purchase-block
 */

// Module dependencies
import 'protons';

// Module styles
import './_purchase-block.scss';

// Module template
import './_purchase-block.twig';

export const name = 'purchase-block';

export const defaults = {
  dummyClass: 'js-purchase-block-exists',
};

/**
 * Components may need to run clean-up tasks if they are removed from DOM.
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Pertinent settings
 */
// eslint-disable-next-line no-unused-vars
export function disable($context, settings) {}

/**
 * Each component has a chance to run when its enable function is called. It is
 * given a piece of DOM ($context) and a settings object. We destructure our
 * component key off the settings object and provide an empty object fallback.
 * Incoming settings override default settings via Object.assign().
 *
 * @param {jQuery} $context - A piece of DOM
 * @param {Object} settings - Settings object
 */
(function ($, $context) {
  // Default $context to `document` if not provided
  $context = $context || document;

  // In mobile layout open the "Details" accordion which has "wedgelok-configure" section and scroll down to it.
  $('.purchase-block__wedgelock-configure .button', $context).on(
    'click',
    function (e) {
      e.preventDefault();

      const tabHeader = $(
        '.tabs-block__tab__accordion-header[data-tab="Details"]'
      );
      const tabContent = $('#Details');
      const activeTabHeader = $('.tabs-block__tab__accordion-header.active');
      const activeTabContent = $('.tabs-block__tab__content:visible');
      const tabLink = $('.tablink.Details');
      const activeTabLink = $('.tablink.active');

      const scrollToSection = (offset) => {
        // Scroll to the `#wedgelok-configure` div
        $('html, body').animate(
          {
            scrollTop: $('#wedgelok-configure').offset().top - offset,
          },
          800
        );
      };

      const closeOtherTabs = (isMobile) => {
        if (isMobile) {
          if (activeTabHeader.length && !tabHeader.is(activeTabHeader)) {
            activeTabHeader.removeClass('active');
            activeTabContent.addClass('disable').hide();
          }
        } else if (activeTabLink.length && !tabLink.is(activeTabLink)) {
          activeTabLink.removeClass('active').addClass('disable');
          activeTabContent.removeClass('active').addClass('disable');
        }
      };

      const openDetailsTab = (isMobile) => {
        if (isMobile) {
          if (!tabContent.is(':visible')) {
            tabHeader.addClass('active');
            tabContent.removeClass('disable').show();
          }
        } else if (!tabContent.hasClass('active')) {
          tabLink.addClass('active').removeClass('disable');
          tabContent.addClass('active').removeClass('disable');
        }
      };

      if ($(window).width() < 720) {
        closeOtherTabs(true);
        openDetailsTab(true);
        scrollToSection(100);
      } else {
        closeOtherTabs(false);
        openDetailsTab(false);
        scrollToSection(200);
      }
    }
  );
})(jQuery, document);
